// ======================================================================
// File Name       : GroupUserNotAdminEditList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormControl, Row, Col, Table, Button } from 'react-bootstrap';
import ModalWrapper from '../../components/modal/ModalWrapper';
import SelectBox from '../../components/SelectBox';
import Pagination from '../../components/Pagination';
import * as groupActions from '../../actions/GroupAction';
import * as modalActions from '../../actions/ModalAction';
import * as commonUtils from '../../utils';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import { REDIRECT_MODAL } from '../../constants/GroupConstants';
import { RETURN_MAX_NUM } from '../../constants';
import { USER_TYPE_DISPLAY_LIST } from '../../constants/UserConstants';
import MessageSearch from '../../components/MessageSearch';

class GroupUserNotAdminEditList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(this.props.editingUserGroupNotAdmin === nextProps.editingUserGroupNotAdmin);
  }

  render() {
    const { editingUserGroupNotAdmin } = this.props;
    const editingNotAdminGroup = Object.keys(editingUserGroupNotAdmin).sort((a, b) => {
      if (editingUserGroupNotAdmin[a].addNew && !editingUserGroupNotAdmin[b].addNew) {
        return -1;
      } else if (!editingUserGroupNotAdmin[a].addNew && editingUserGroupNotAdmin[b].addNew) {
        return 1;
      }
      if (editingUserGroupNotAdmin[a].index < editingUserGroupNotAdmin[b].index) {
        return -1;
      } else if (editingUserGroupNotAdmin[a].index > editingUserGroupNotAdmin[b].index) {
        return 1;
      }
      return 0;
    });
    return (
      <div>
        <Form.Group className="form-info margin-top-50" id="scroll-table-not-admin">
          <Col as={Form.Label} sm={7} className="margin-top-15 padding-clear">
            所属受講ユーザー
          </Col>
          <Col sm={5} className="text-right padding-clear">
            <Button variant="default" onClick={this.props.handleRemoveAll}>ユーザ一一括削除</Button>
          </Col>
          <Col sm={12} className="padding-clear">
            <Table striped hover className="margin-top-7 margin-bottom-0">
              <thead>
                <tr>
                  <th>ユーザー種別</th>
                  <th>ユーザー名</th>
                  <th>ログインID</th>
                  <th className="col-md-1">操作</th>
                </tr>
              </thead>
              <tbody>
                {editingNotAdminGroup.map((userSecernId, index) => {
                  const data = editingUserGroupNotAdmin[userSecernId]
                    ? editingUserGroupNotAdmin[userSecernId]
                    : {};
                  return (
                    <tr key={index} className={data.addNew ? 'background_new_record' : ''}>
                      <td>{commonUtils.getItemBoxName(USER_TYPE_DISPLAY_LIST, data.userType)}</td>
                      <td>{data.userName}</td>
                      <td>{data.loginId}</td>
                      <td className="text-center">
                        <i
                          role="button"
                          className="bi bi-trash"
                          onClick={this.props.handleRemoveUser.bind(null, userSecernId)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Form.Group>
        <Col sm={12} className="text-center padding-top-10">
          <Button variant="default" style={{ marginRight: '5px' }} onClick={this.props.handleBackBtn} className="btn-96">
            {'戻る'}
          </Button>
          <Button variant="primary" className="btn-96" onClick={this.props.handleNextBtn}>
            {'OK'}
          </Button>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authority } = state;
  return { group, authority: authority.authorityInfo };
};
export default connect(mapStateToProps)(GroupUserNotAdminEditList);
